import type { PackageStatus } from '../enums/PackageStatus'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class PackageFilterEntity {
  id?: string
  packageStatus?: PackageStatus
  user?: UserMiniEntity
  service?: ServiceMiniEntity
  region?: RegionMiniEntity
  referenceCode?: string
  fromDate?: string
  toDate?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
